export const DEFAULT_LOCATE = "vi";
export const LOCATES = ["vi", "en"];

export const COOKIE_SUPPLIER_TOKEN = 'supplier_token'
export const LOCAL_STORAGE_SUPPLIER = 'supplier'

export const API = {
  order: {
    detail: "/v1/order/detail"
  },
  supplier: {
    file: "/v1/supplier/file",
    locate_supplier: "/v1/order/locate_supplier",
    rating: "/v1/order/rate_supplier",
    file_upload: "/public/v2/ops/file_upload/",
    upload_file: "/v1/supplier/upload_file"
  }
};

export const ORDER_STATUS = {
  ALL: "ALL",
  IDLE: "IDLE",
  ASSIGNING: "ASSIGNING",
  ACCEPTED: "ACCEPTED",
  IN_PROCESS: "IN PROCESS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  FAILED: "FAILED",
  RETURNING: "RETURNING",
  RETURNED: "RETURNED",
  PICKED_UP: "PICKED_UP",
  BOARDED: "BOARDED"
};

export const STEP_STATUS = {
  ENABLED: "enabled",
  DISABLED: "disabled",
  FAILED: "failed"
};

export const PARTNER = {
  SENDO: "sendo",
  HEINEKEN: "heineken",
  DRINKIES: "drinkies",
  LAZADA: "lazada"
};

export const AUTHENTICATE_TYPE = {
  AHAMOVE: "ahamove",
  FIREBASE: "firebase"
};

export const NUMBER_OF_ACTIVATE_CODE = {
  FIREBASE: 6,
  AHAMOVE: 4
};

export const ONBOARD_STATUS = {
  PROCESSING: "processing",
  SUCCESS: "success"
};

export const TIME = {
  MONTHS: [
    "Tháng 1",
    "Tháng 2",
    "Tháng 3",
    "Tháng 4",
    "Tháng 5",
    "Tháng 6",
    "Tháng 7",
    "Tháng 8",
    "Tháng 9",
    "Tháng 10",
    "Tháng 11",
    "Tháng 12"
  ],
  DAYS: ["T2", "T3", "T4", "T5", "T6", "T7", "CN"]
};

export const CATEGORIES = {
  FEATURED : 'FEATURED'
}

export const DATA = {
  ID_ISSUE_PLACE: [
    "Công An Thành phố Hồ Chí Minh",
    "Công An Thành phố Hà Nội",
    "Cục CS ĐKQL Cư Trú và DLQG về dân cư",
    "Công An Tỉnh Hà Giang",
    "Công An Tỉnh Cao Bằng",
    "Công An Tỉnh Bắc Kạn",
    "Công An Tỉnh Tuyên Quang",
    "Công An Tỉnh Lào Cai",
    "Công An Tỉnh Điện Biên",
    "Công An Tỉnh Lai Châu",
    "Công An Tỉnh Sơn La",
    "Công An Tỉnh Yên Bái",
    "Công An Tỉnh Hoà Bình",
    "Công An Tỉnh Thái Nguyên",
    "Công An Tỉnh Lạng Sơn",
    "Công An Tỉnh Quảng Ninh",
    "Công An Tỉnh Bắc Giang",
    "Công An Tỉnh Phú Thọ",
    "Công An Tỉnh Vĩnh Phúc",
    "Công An Tỉnh Bắc Ninh",
    "Công An Tỉnh Hải Dương",
    "Công An Thành phố Hải Phòng",
    "Công An Tỉnh Hưng Yên",
    "Công An Tỉnh Thái Bình",
    "Công An Tỉnh Hà Nam",
    "Công An Tỉnh Nam Định",
    "Công An Tỉnh Ninh Bình",
    "Công An Tỉnh Thanh Hóa",
    "Công An Tỉnh Nghệ An",
    "Công An Tỉnh Hà Tĩnh",
    "Công An Tỉnh Quảng Bình",
    "Công An Tỉnh Quảng Trị",
    "Công An Tỉnh Thừa Thiên Huế",
    "Công An Thành phố Đà Nẵng",
    "Công An Tỉnh Quảng Nam",
    "Công An Tỉnh Quảng Ngãi",
    "Công An Tỉnh Bình Định",
    "Công An Tỉnh Phú Yên",
    "Công An Tỉnh Khánh Hòa",
    "Công An Tỉnh Ninh Thuận",
    "Công An Tỉnh Bình Thuận",
    "Công An Tỉnh Kon Tum",
    "Công An Tỉnh Gia Lai",
    "Công An Tỉnh Đắk Lắk",
    "Công An Tỉnh Đắk Nông",
    "Công An Tỉnh Lâm Đồng",
    "Công An Tỉnh Bình Phước",
    "Công An Tỉnh Tây Ninh",
    "Công An Tỉnh Bình Dương",
    "Công An Tỉnh Đồng Nai",
    "Công An Tỉnh Bà Rịa - Vũng Tàu",
    "Công An Tỉnh Long An",
    "Công An Tỉnh Tiền Giang",
    "Công An Tỉnh Bến Tre",
    "Công An Tỉnh Trà Vinh",
    "Công An Tỉnh Vĩnh Long",
    "Công An Tỉnh Đồng Tháp",
    "Công An Tỉnh An Giang",
    "Công An Tỉnh Kiên Giang",
    "Công An Thành phố Cần Thơ",
    "Công An Tỉnh Hậu Giang",
    "Công An Tỉnh Sóc Trăng",
    "Công An Tỉnh Bạc Liêu",
    "Công An Tỉnh Cà Mau"
  ],
  ID_NATIVE_PLACE: [
    "TP HCM",
    "Hà Nội",
    "An Giang",
    "Bà Rịa - Vũng Tàu",
    "Bắc Giang",
    "Bắc Kạn",
    "Bạc Liêu",
    "Bắc Ninh",
    "Bến Tre",
    "Bình Định",
    "Bình Dương",
    "Bình Phước",
    "Bình Thuận",
    "Cà Mau",
    "Cao Bằng",
    "Đắk Lắk",
    "Đắk Nông",
    "Điện Biên",
    "Đồng Nai",
    "Đồng Tháp",
    "Gia Lai",
    "Hà Giang",
    "Hà Nam",
    "Hà Tĩnh",
    "Hải Dương",
    "Hải Phòng",
    "Hậu Giang",
    "Hòa Bình",
    "Hưng Yên",
    "Khánh Hòa",
    "Kiên Giang",
    "Kon Tum",
    "Lai Châu",
    "Lâm Đồng",
    "Lạng Sơn",
    "Lào Cai",
    "Long An",
    "Nam Định",
    "Nghệ An",
    "Ninh Bình",
    "Ninh Thuận",
    "Phú Thọ",
    "Quảng Bình",
    "Quảng Nam",
    "Quảng Ngãi",
    "Quảng Ninh",
    "Quảng Trị",
    "Sóc Trăng",
    "Sơn La",
    "Tây Ninh",
    "Thái Bình",
    "Thái Nguyên",
    "Thanh Hóa",
    "Thừa Thiên Huế",
    "Tiền Giang",
    "Trà Vinh",
    "Tuyên Quang",
    "Vĩnh Long",
    "Vĩnh Phúc",
    "Yên Bái",
    "Phú Yên",
    "Cần Thơ",
    "Đà Nẵng"
  ]
};
